<template>
    <div>

        <!------------------------------------------------
            Alert for Mobile
        ------------------------------------------------->

        <v-alert
            v-if="$vuetify.breakpoint.smAndDown"
            v-model="mobileAlert"
            dense text
            type="info"
        >
            <v-row align="center">
                <v-col class="grow" v-text="$gettext('Long press an app to view options.')"></v-col>
                <v-col class="shrink" @click="setMobileAlert(false)">
                    <v-btn class="primary btn" small v-text="$gettext('Okay')"></v-btn>
                </v-col>
            </v-row>
        </v-alert>

        <!------------------------------------------------
            Device
        ------------------------------------------------->

        <div v-if="chosenModel"
             :class="{'smartphone-border': !isDark, 'smartphone-border-dark': isDark}"
             class="smartphone smartphone-width">
            <div :title="chosenModel" class="device-name text-truncate cursor-default" v-text="chosenModel"></div>
            <div :class="{'smartphone-content-background': !isDark, 'smartphone-content-background-dark': isDark}"
                 class="smartphone-content smartphone-content-height overflow-y-auto">
                <div class="mt-0">
                    <!-- configurations[currentSelectedConfigurationIndex].value.phone_model[chosenModel]-->
                    <!-- Search bar-->
                    <!--                        append-outer-icon="mdi-order-bool-ascending"-->
                    <v-text-field
                        v-if="(filteredCurrentApplications['length'] > 0 || (filteredCurrentApplications['length'] < 1 && appFilterText.length > 0))"
                        v-model="appFilterText"
                        :label="$gettext('Search')"
                        append-icon="mdi-magnify"
                        autocomplete="off"
                        class="mb-2"
                        hide-details
                        rounded
                        single-line
                    >
                        <!------------------------------------------------
                            Customize append-outer-icon
                        ------------------------------------------------->

                        <!--                        <template v-slot:append-outer>
                                                    <v-icon :class="{'text&#45;&#45;primary': configurations[currentSelectedConfigurationIndex].value['reorder_icons']}" :title="$gettext('Toggle the state of reorder icons')"
                                                            class="mr-2"
                                                            @click="toggleReorderIcons"
                                                            v-text="icons.mdiOrderBoolAscending"
                                                    ></v-icon>
                                                </template>-->

                    </v-text-field>
                    <v-divider
                        v-if="(filteredCurrentApplications['length'] > 0 || (filteredCurrentApplications['length'] < 1 && appFilterText.length > 0))"
                        class="mb-4"></v-divider>

                    <device-searching-text v-if="hasAppAndHasFilterText"
                                           :search-term="appFilterText"></device-searching-text>

                    <!-- Search icon, info icon
                    <v-btn-toggle rounded dense class="mb-2 mr-3 d-flex justify-end">
                        <v-btn>
                            <v-icon class="my-2 mr-1" v-text="icons.mdiMagnify"></v-icon>
                        </v-btn>
                        <v-btn>
                            <v-icon class="my-2 mr-1" v-text="icons.mdiInformation"></v-icon>
                        </v-btn>
                    </v-btn-toggle>
                    -->

                    <device-no-apps-found
                        v-if="emptyCurrentApplicationsAndHasFilterText"
                        :filter-text="appFilterText">
                    </device-no-apps-found>

                    <div v-else-if="filteredCurrentApplications['length'] < 1 && appFilterText.length < 1"
                         class="text-center">
                        <div class="subtitle-2 mt-6">
                            {{ $gettext('No apps are chosen for this device yet.') }}
                        </div>
                    </div>

<!--                        @add="() => { removeDuplicatePackageForCurrentConfiguration(); refreshFilteredApplications() }"-->
                    <draggable
                        v-model="configurations[currentSelectedConfigurationIndex].value.applications"
                        :group="{ name: 'apps', pull: false, put: true }"
                        :options="{disabled : $vuetify.breakpoint.smAndDown, filter:'.ignore-app'}"
                        :sort="true"
                        class="app-grid overflow-y-auto top-app-grid-with-search"
                        @sort="(val) => { sorted(val) }"
                        @add="(evt) => handleAppAddedToDevice(evt)"
                    >
                        <!-- :currentSelectedConfigurationIndex="currentSelectedConfigurationIndex"-->
                        <!-- with this the internal sorting is not working v-for="(phone, key) in filteredCurrentApplications"-->

                        <app-icon
                            v-for="(phone, key) in configurations[currentSelectedConfigurationIndex].value.applications"
                            v-if="doesAppMatchFilterText(phone)"
                            :key="phone.packageId"
                            :app-name="phone.appName ? phone.appName : phone.appName"
                            :app-params="phone"
                            :device-name="chosenModel"
                            :folder-name="getPhoneTypeDirForDevice(chosenModel)"
                            :group="'apps'+currentSelectedConfigurationIndex"
                            :package-name="phone.packageId ? phone.packageId : phone.packageId"
                            :showMenu="showMenu"
                            :x="x"
                            :y="y"
                            class="cursor-move"
                            @changeShowMenu="(val) => updateShowMenu(val, phone.packageId)"
                            @forceReRender="() => refreshFilteredApplications()"
                            @openAddEditAppTimeCondition="(val) => openAddEditAppDialog(val)"
                        />
                        <v-spacer></v-spacer>
                    </draggable>
                </div>
            </div>
        </div>

        <snackbar ref="snackbar"></snackbar>
        <!-- Even though we are not using this for add, but we are using this for edit -->
        <dialog-apps-add-edit v-if="addEditAppDialog" :params="addEditAppParams"></dialog-apps-add-edit>
        <div class="text-center subtitle-2 font-weight-bold mt-5">{{ chosenModel }}
        </div>

        <v-menu>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :title="$gettext('Click for options')" icon
                       v-bind="attrs"
                       v-on="on"
                       class="d-flex mx-auto"
                >
                    <v-icon small v-text="icons.mdiDotsHorizontal"></v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item class="cursor-pointer" dense @click.prevent.stop="toggleReorderIcons()">
                    <v-list-item-title>
                        <v-icon
                            v-if="currentSelectedConfigurationHasReorderIcons"
                            class="primary--text mr-2"
                            small
                            v-text="icons.mdiCheckCircle"></v-icon>
                        <v-icon
                            v-else
                            class="mr-2"
                            size="18" small
                            v-text="icons.mdiRadioboxBlank"></v-icon>
                        {{ $gettext('Allow the user to reorder the icons on his phone') }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>


<script>
// import Vue from 'vue'
// import { reactive, ref, onMounted } from '@vue/composition-api'
import draggable from 'vuedraggable'
import {computed, inject, onMounted, reactive, ref, toRef, watch} from "vue";
import DeviceSearchingText from "@/components/blocks/DeviceSearchingText.vue";
import DeviceNoAppsFound from "@/components/blocks/DeviceNoAppsFound.vue";
import AppIcon from "@/components/devices/AppIcon.vue";
import {mapWritableState, storeToRefs} from "pinia";
import {usePhonesStore} from "@/stores/PhonesStore";
import MixinIcon from "@/mixins/MixinIcon";
import Snackbar from "@/components/Snackbar.vue";
import Constants from "@/assets/js/constants";
import {getPhoneTypeDirForDevice} from "@/composables/getPhoneTypeDirForDevice";
import {findIndex, isInteger} from "lodash";
import DialogAppsAddEdit from "@/components/dialogs/apps/DialogAppsAddEdit.vue";
import {eventBus} from "@/main";
import {useVuetify} from "@/composables/vuetify";


// Vue.use('@vue/composition-api')
// Import MixinIcon

export default {
    name: 'LeftDevice',
    components: {
        DialogAppsAddEdit,
        Snackbar,
        AppIcon,
        DeviceNoAppsFound,
        DeviceSearchingText,
        draggable
    },
    setup(props, context) {

        /**
         * We are having this over here instead of in the child component because otherwise the earlier opened menus are kept open. We needed something that is not just common to all appIcons but dynamic as well. In the future, this should be improved and simplified but for now this works, and we will circle back on this soon.
         */
        let showMenu = ref({value: false, packageName: ''});
        let addEditAppParams = ref({addEditAppDialog: false, app: {}, appIndex: -1});
        let addEditAppDialog = ref(false);
        let x = ref(0);
        let y = ref(0);
        let filteredCurrentApplications = ref([])
        let snackbar = ref(null)
        const mobileAlert = ref(true)
        const appFilterText = ref('')


        function getFilteredCurrentApplications() {

            let filteredApplications = [];

            if (currentSelectedConfigurationIndex.value > -1) {

                let currentConfiguration = configurations.value[currentSelectedConfigurationIndex.value];

                filteredApplications = currentConfiguration?.value?.applications?.filter((application) => {

                    if (appFilterText.value.length < 1) return true;
                    return application.appName.toLowerCase().includes(appFilterText.value.toLowerCase())

                })

            }

            return filteredApplications;

        }

        function toggleReorderIcons() {
            // configurations.value[currentSelectedConfigurationIndex.value].value.reorder_icons = configurations.value[currentSelectedConfigurationIndex.value].value.reorder_icons === 1 ? 0 : 1

            let currentConfig = configurations.value[currentSelectedConfigurationIndex.value].value;
            let newReorderIconsValue = currentConfig.reorder_icons === 1 ? 0 : 1;
            let newConfig = {...currentConfig, reorder_icons: newReorderIconsValue};
            configurations.value[currentSelectedConfigurationIndex.value].value = newConfig;
        }

        watch(appFilterText, (val) => {
            filteredCurrentApplications.value = getFilteredCurrentApplications();
        })

        const phonesStore = usePhonesStore()
        const {
            configurations,
            currentSelectedConfiguration,
            currentSelectedConfigurationIndex,
            chosenModel
        } = storeToRefs(phonesStore);

        watch(configurations, (val) => {
            filteredCurrentApplications.value = getFilteredCurrentApplications();
        })

        filteredCurrentApplications.value = getFilteredCurrentApplications();

        watch(chosenModel, (val) => {
            filteredCurrentApplications.value = getFilteredCurrentApplications();
        })

        const icons = MixinIcon.data().icons

        function readAndSetMobileAlertFromLocalStorage() {

            try {
                let val = localStorage.getItem(Constants.localStorageMobileAppsTabAlertForLongPress)
                if (val === 'false') {
                    mobileAlert.value = false
                }
            } catch (e) {
                // console.log(e)
                // TODO: Handle this
            }

        }


        let hasAppAndHasFilterText = computed(function () {
            return (filteredCurrentApplications.value['length'] > 0 && appFilterText.value.length > 0)
        })

        let emptyCurrentApplicationsAndHasFilterText = computed(function () {
            return (filteredCurrentApplications.value['length'] < 1 && appFilterText.value.length)
        })

        function setMobileAlert(val) {

            try {

                // this.mobileAlert = val
                mobileAlert.value = val
                localStorage.setItem(Constants.localStorageMobileAppsTabAlertForLongPress, val)

            } catch (e) {
                // console.log(e)
                // TODO: Handle this
            }

        }

        /**
         *
         * This is used to remove duplicate packages for the current configuration. This is used when we are adding an application to the current configuration and we want to make sure that we are not adding the same application twice.
         *
         * This is specially necessary when the application is dropped at that time we are already having a duplicate application, and we want to smartly remove only the added application from the duplication.
         *
         * @param packageId
         * @param appName
         * @param newIndex
         */
        function removeDuplicatePackageForCurrentConfiguration(packageId, appName, newIndex = false) {

            let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
            let firstOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId))

            if (firstOccurrenceIndex > -1) {

                let secondOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId), firstOccurrenceIndex + 1)

                if (secondOccurrenceIndex > -1 && isInteger(newIndex) && newIndex > -1) {
                    applications.splice(newIndex, 1)
                    // add $gettext for composition api
                    snackbar.value.showSnackbar(appName + ' ' + $gettext('is already installed for the device') + ' ' + chosenModel.value, 'info')
                }
            }

        }

        /**
         *
         * TODO: Make a mixin of the method
         *
         * Not that it is significant but know that this is being called twice by AppIcon
         * @param val
         * @param packageName
         */
        function updateShowMenu(val, packageName) {

            // TODO: This if is no help, remove it.
            if (val.packageName === packageName) {

                showMenu.value.value = val.value
                showMenu.value.packageName = val.packageName

                x.value = val.x
                y.value = val.y

            }

        }

        function refreshFilteredApplications() {
            filteredCurrentApplications.value = getFilteredCurrentApplications();
        }

        function appsGetIndex(currentSelectedConfigurationIndex, packageId) {
            return findIndex(configurations.value[currentSelectedConfigurationIndex.value].value.applications, {packageId: packageId})
        }

        function openAddEditAppDialog(app) {

            let appIndex = appsGetIndex(currentSelectedConfigurationIndex, app.packageId)

            addEditAppParams.value = {
                addEditAppDialog: true,
                app,
                appIndex,
                chosenModel: chosenModel.value,
                currentSelectedConfiguration: currentSelectedConfiguration.value,
                currentSelectedConfigurationIndex: currentSelectedConfigurationIndex.value,
            }

            addEditAppDialog.value = true

        }

        let closeDialog = function (dialogName) {
            let self = this;
            addEditAppDialog.value = false;
        }

        // listen to event update-app-list
        eventBus.$on('update-app-list', (currentSelectedConfiguration) => {
            refreshFilteredApplications()
        })

        let sorted = function (val) {
        }

        let doesAppMatchFilterText = function (app) {
            if (appFilterText.value.length > 0) {
                return app.appName.includes(appFilterText.value)
            }
            return true;
        }

        function handleAppAddedToDevice(evt) {

            const packageId = evt.item?.id;

            if (packageId) {

                const availableApps = configurations.value[currentSelectedConfigurationIndex.value].value.installed_applications;
                const appIndex = findIndex(availableApps, application => application.packageId === packageId);

                if (appIndex > -1) {
                    availableApps.splice(appIndex, 1);
                }

            }

            removeDuplicatePackageForCurrentConfiguration();
            refreshFilteredApplications();
        }

        onMounted(() => {
            readAndSetMobileAlertFromLocalStorage();
        })

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })

        const currentSelectedConfigurationHasReorderIcons = computed(() => {
            return configurations.value[currentSelectedConfigurationIndex.value].value.reorder_icons === 1
        })

        return {
            mobileAlert,
            appFilterText,
            setMobileAlert,
            hasAppAndHasFilterText,
            emptyCurrentApplicationsAndHasFilterText,
            configurations, currentSelectedConfiguration, currentSelectedConfigurationIndex, chosenModel,
            icons,
            refreshFilteredApplications,
            getPhoneTypeDirForDevice,
            filteredCurrentApplications,
            getFilteredCurrentApplications,
            toggleReorderIcons,
            removeDuplicatePackageForCurrentConfiguration,
            x,
            y,
            showMenu,
            openAddEditAppDialog,
            addEditAppDialog,
            addEditAppParams,
            updateShowMenu,
            closeDialog,
            sorted,
            doesAppMatchFilterText,
            snackbar,
            isDark,
            currentSelectedConfigurationHasReorderIcons,
            handleAppAddedToDevice
        }
    },
}
</script>
<style type="text/scss">
.app-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-rows: repeat(6, 1fr);
    row-gap: 20px;
    column-gap: 10px;
}

.device-name {
    content: "LightPhone";
    width: 100px;
    color: white;
    left: 10px;
    position: absolute;
    top: -41px;
    font-weight: bold;
    /*letter-spacing: 1px;*/
    font-size: 14px;
}

.top-app-grid {
    height: 480px;
}

.top-app-grid-with-search {
    height: 380px;
}

@import "../../assets/scss/smartphone.css";

</style>
